import OtpInput from "./OtpInput";
import { handleErrMessage } from "../../functions/handleErrMessage";
import { LoaderCircle, MoveRight } from "lucide-react";

const OtpVerificationForm = ({
  otp,
  phone,
  inputRefs,
  timeLeft,
  timerActive,
  handleOtpChange,
  handleKeyDown,
  handlePaste,
  resendOtpHandler,
  verifyStatus,
  resendStatus,
}) => {
  // ===============================================
  // VERIFY OPT STATUS
  // ===============================================
  const { loading: verifyLoading, error: verifyError } = verifyStatus;
  // ===============================================
  // RESEND OPT STATUS
  // ===============================================
  const { loading: resendLoading, error: resendError } = resendStatus;
  return (
    <>
      <h3 className="text-center text-xl sm:text-3xl pb-2 font-figtreeMedium">
        OTP Verification
      </h3>
      <p className="text-center text-gray-600">Enter the OTP sent to {phone}</p>

      <OtpInput
        otp={otp}
        inputRefs={inputRefs}
        handleOtpChange={handleOtpChange}
        handleKeyDown={handleKeyDown}
        handlePaste={handlePaste}
      />
      <p className="text-center mb-4 sm:mb-8 text-gray-600 text-sm">
        Otp Valid for 10 min
      </p>
      {timerActive ? (
        <p className="text-center max-sm:text-sm">
          Resend OTP in {timeLeft} seconds
        </p>
      ) : (
        <div className="flex justify-center gap-2 items-center max-sm:text-sm">
          <p>Didn't Receive otp?</p>
          <button
            type="button"
            onClick={resendOtpHandler}
            className="text-blue-600 underline"
            disabled={resendLoading}
          >
            {" "}
            Resend OTP{" "}
          </button>
          {resendLoading && (
            <LoaderCircle className="animate-spin text-blue-600" size={20} />
          )}
        </div>
      )}

      {resendError && (
        <p className="loginOtpErr mt-3">{handleErrMessage(resendError)}</p>
      )}
      {verifyError && (
        <p className="loginOtpErr mt-3">{handleErrMessage(verifyError)}</p>
      )}

      <button
        className={`loginBtn ${
          otp.join("").length !== 6 ? "opacity-70" : "hover:bg-db2"
        }`}
        disabled={otp.join("").length !== 6 || verifyLoading}
      >
        {verifyLoading ? (
          <>
            <LoaderCircle className="animate-spin mr-2" size={25} /> Loading...
          </>
        ) : (
          <>
            VERIFY OTP <MoveRight className="ml-2" />
          </>
        )}
      </button>
    </>
  );
};

export default OtpVerificationForm;
